import React from 'react';
import { trackPixelEvent } from '../utils/metaPixel';
export function OfferSection() {
  return <section id="offerta" className="py-6 md:py-9 px-5 bg-gradient-to-b from-dark-bg to-card-bg text-center" data-id="element-116" data-mp="3nsl19k76rdl">
      <div className="max-w-[900px] mx-auto" data-id="element-117" data-mp="8mn6kj9juu1e">
        <span className="inline-block font-heading font-bold text-[0.75rem] tracking-[3px] uppercase text-magenta-bright mb-2" data-id="element-118" data-mp="de57567nuslu">
          L'investimento
        </span>
        <h2 className="font-heading font-black mb-3 text-[23px]" data-id="element-119" data-mp="icyml46icton">
          Tutto ciò che ti serve per
          <br data-id="element-120" data-mp="md0fooy6gesb" />
          <span className="text-gradient-magenta" data-id="element-121" data-mp="mgo81krvyv5g">
            interrompere il ciclo — oggi
          </span>
        </h2>
        {/* Offerta unica: Materiale completo */}
        <div className="max-w-[550px] mx-auto mt-3" data-id="element-122" data-mp="wchjf0tvciln">
          <div className="w-full text-left rounded-2xl p-4 md:p-5 border-2 border-magenta-bright shadow-[0_0_30px_rgba(255,45,155,0.2)] bg-card-bg" data-id="element-123" data-mp="2t5t0ysrdo50f">
            <div className="flex items-center gap-3 md:gap-4" data-id="element-124" data-mp="2y4meumakty14">
              <img src="https://cdn.magicpatterns.com/uploads/gMnXrGWDjQiWBmwdVkGa8e/Gemini_Generated_Image_dm2y9fdm2y9fdm2y.jpg" alt="Collezione Piacere, Colpa e Vuoto — 4 volumi" className="w-[110px] md:w-[150px] h-auto shrink-0 rounded-lg drop-shadow-[0_6px_20px_rgba(194,0,111,0.45)]" data-id="element-125" data-mp="12ns6pivrp13x" />
              <div className="flex-1 min-w-0" data-id="element-126" data-mp="ouaihks4z07k">
                <h3 className="font-heading font-black text-[1rem] md:text-[1.2rem] text-white leading-tight" data-id="element-127" data-mp="1llbekj6hodor">
                  ⚡ MATERIALE COMPLETO — FORMATO DIGITALE
                </h3>
                <p className="text-white/60 text-[0.8rem] mt-1 leading-snug" data-id="element-128" data-mp="1ckwt9jtiyyl9">
                  4 volumi PDF + 3 bonus in regalo
                </p>
                <div className="flex items-baseline gap-2.5 mt-2" data-id="element-129" data-mp="17opkzkdnpb05">
                  <p className="text-white/40 text-[0.8rem] line-through" data-id="element-130" data-mp="17at73m4ncky">
                    59 €
                  </p>
                  <p className="font-heading font-black text-[1.5rem] md:text-[1.85rem] text-magenta-bright leading-none" data-id="element-131" data-mp="3sbj0c4mv602a">
                     € 19
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* CTA Button */}
        <div className="max-w-[550px] mx-auto mt-5" data-id="element-132" data-mp="3ksjjo6qsemmm">
          <a href="https://piacere-colpa-e-vuoto-4-volumi.impultienda.ar/checkout" onClick={() => trackPixelEvent('InitiateCheckout', {
          content_name: 'Materiale completo — 4 volumi + 3 bonus',
          value: 19,
          currency: 'EUR'
        })} className="block text-center w-full bg-gradient-to-br from-magenta to-magenta-bright text-white font-heading font-black text-[1.15rem] md:text-[1.3rem] py-5 px-5 rounded-2xl uppercase tracking-[1px] shadow-[0_8px_30px_rgba(194,0,111,0.5),0_0_60px_rgba(194,0,111,0.2)] transition-[transform,box-shadow] duration-200 ease-out hover:-translate-y-[3px] hover:shadow-[0_12px_40px_rgba(194,0,111,0.7),0_0_80px_rgba(194,0,111,0.3)]" data-id="element-133" data-mp="3oumvwxla5v8y">
            SÌ, VOGLIO IL MATERIALE COMPLETO
          </a>
          <p className="text-white/70 text-[0.9rem] font-heading font-semibold mt-4" data-id="element-134" data-mp="28kez37gk0ods">
            🌎 Paghi nella valuta del tuo paese
          </p>
          <div className="flex justify-center mt-2" data-id="element-135" data-mp="2ih9wto506kr0">
            <img src="https://cdn.magicpatterns.com/uploads/iAwRVcP6c5wjxBYiWFb4cu/descarga.png" alt="Metodi di pagamento: Visa, Mastercard, PayPal" className="h-[32px] md:h-[38px] w-auto object-contain opacity-70" data-id="element-136" data-mp="2ifgqyb27s4k2" />
          </div>
          <p className="text-white/50 text-[0.95rem] italic mt-3 leading-relaxed" data-id="element-137" data-mp="365b1glz29h15">
            L'opzione più scelta da chi vuole
            <br className="hidden sm:block" data-id="element-138" data-mp="319m850dmwwda" /> guarire davvero
          </p>
        </div>
        {/* Trust Badges */}
        <div className="max-w-[550px] mx-auto mt-5 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-[0.85rem] text-white/60" data-id="element-139" data-mp="3a87p4r3gk3by">
          <span className="flex items-center gap-2" data-id="element-140" data-mp="18hz4zy79r8yf">
            <span className="text-magenta-bright" data-id="element-141" data-mp="1di4zdm4xb9k7">🔒</span> Pagamento sicuro
          </span>
          <span className="flex items-center gap-2" data-id="element-142" data-mp="1dfs7ag5gbitf">
            <span className="text-magenta-bright" data-id="element-143" data-mp="1i9wixcpnwf0u">⏱️</span> Accesso immediato
          </span>
        </div>
        <div className="max-w-[550px] mx-auto mt-2 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-[0.8rem] text-white/40" data-id="element-144" data-mp="1m95aqc1562tr">
          <span className="flex items-center gap-1.5" data-id="element-145" data-mp="pmirfu4qgbo4">
            🛡️ Pagamento protetto
          </span>
          <span data-id="element-146" data-mp="ykug3qm1gzdx">•</span>
          <span className="flex items-center gap-1.5" data-id="element-147" data-mp="ykkz2siz22kd">
            📦 Nessun abbonamento
          </span>
        </div>
      </div>
    </section>;
}